import {StyleSheet, TextInput as RN_TextInput} from "react-native";
import {useContext} from "react";
import AppConfigContext from "../../contexts/AppConfigContext";

function TextInput(props: any) {
    const lang = useContext(AppConfigContext).lang;
    const style = StyleSheet.create({
        main: {
            writingDirection: lang == "fa" ? "rtl" : "ltr",
        }
    })
    return <RN_TextInput {...props} style={[style.main, props.style]}/>
}

export {TextInput};